import React, { useState, useEffect } from 'react'
import DeleteIcon from '@mui/icons-material/Delete'
import DownloadIcon from '@mui/icons-material/Download'
import EditIcon from '@mui/icons-material/Edit'
import IconButton from '@mui/material/IconButton'
import Pagination from '@mui/material/Pagination'
import Paper from '@mui/material/Paper'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import PlayDisabledIcon from '@mui/icons-material/PlayDisabled'
import Stack from '@mui/material/Stack'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import VisibilityIcon from '@mui/icons-material/Visibility'
import NewWizardDialog from '../ui/tasks/createWizard/NewWizardDialog'
import { dateParser } from '../utilities/helperFunctions'

function TabDataTools(props) {
    const [sqLDbList, setSqLDbList] = useState([])
    const [dbJobs, setDbJobs] = useState([])
    const [ssisJobs, setSsisJobs] = useState([])
    const [dbHistoryEntries, setDbHistoryEntries] = useState([])
    const [allGlobalFiles, setAllGlobalFiles] = useState([])
    const [performingJob, setPerformingJob] = useState(false)
    const [currentJobProgress, setCurrentJobProgress] = useState(0)
    const [currentJobTotalParts, setCurrentJobTotalParts] = useState(1)
    const [jobProgressId, setJobProgressId] = useState(-1)

    const [totalPagesForGlobalFiles, setTotalPagesForGlobalFiles] = useState(1)
    const [filesPage, setFilesPage] = useState(1)

    const [totalPagesForJobs, setTotalPagesForJobs] = useState(1)
    const [jobsPage, setJobsPage] = useState(1)

    const [totalPagesForHistories, setTotalPagesForHistories] = useState(1)
    const [historiesPage, setHistoriesPage] = useState(1)

    // Extra functionality, select a jobs row
    const [selectedJob, setSelectedJob] = useState(null)

    // Wizard data tools variables
    const [wizardStep, setWizardStep] = useState('')
    const [headerRow, setHeaderRow] = useState(0)
    const [factSourceFirstRow, setFactSourceFirstRow] = useState(-1)
    const [tableDefinition, setTableDefinition] = useState({
        "tableHasHeader": false,
        "namedColumns": false
    })
    const [factsColumnRanges, setFactsColumnRanges] = useState([])
    const [dimensions, setDimensions] = useState([])
    const [aggregationSelections, setAggregationSelections] = useState([])
    const [selectedDimension, setSelectedDimension] = useState({ "id": -1, "name": "", "outputFormat": [], "ranges": [], "segments": [], "type": 1 })
    const [wizardFileName, setWizardFileName] = useState('')
    const [wizardFileId, setWizardFileId] = useState(-1)

    const SSIS_JOB_TYPE = 1
    const DB_JOB_TYPE = 2
    const ENTRIES_PER_PAGE = 5

    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.dbList
            setSqLDbList(dBList)
        }

        // Fill in DB Jobs
        if (dbJobs.length === 0 && props.jobs.length > 0) {
            let dbJobs = props.jobs.filter(x => x.jobType === DB_JOB_TYPE)
            let ssisPackages = props.jobs.filter(x => x.jobType === SSIS_JOB_TYPE)
            if (dbJobs.length > 0) {
                setDbJobs(dbJobs)
                let totalPages = Math.ceil(props.jobs.length / ENTRIES_PER_PAGE)
                setTotalPagesForJobs(totalPages)
            }
            if (ssisPackages.length > 0) {
                setSsisJobs(ssisPackages)
            }
        }

        if (props.jobs.length > 0) {
            // Get the DB Job History List
            sortHistories(props.jobs, props.histories)
        }

        if (props.globalFiles.length > 0) {
            setAllGlobalFiles(props.globalFiles)
            let totalPages = Math.ceil(props.globalFiles.length / ENTRIES_PER_PAGE)
            setTotalPagesForGlobalFiles(totalPages)
        }
    }, [])

    useEffect(() => {
        setPerformingJob(props.selfServeJobs.performingJob)
        setCurrentJobProgress(props.selfServeJobs.currentJobProgress)
        setCurrentJobTotalParts(props.selfServeJobs.currentJobTotalParts)
        setJobProgressId(props.selfServeJobs.jobProgressId)
    }, [props.selfServeJobs])

    useEffect(() => {
        let jobs = props.jobs.filter(x => x.jobType === DB_JOB_TYPE)
        setDbJobs(jobs)
        setSsisJobs(props.jobs.filter(x => x.jobType === SSIS_JOB_TYPE))

        let totalJobsPages = Math.ceil(props.jobs.filter(x => x.jobType === DB_JOB_TYPE).length / ENTRIES_PER_PAGE)
        setTotalPagesForJobs(totalJobsPages)
        sortHistories(jobs, props.histories)
    }, [props.jobs])

    useEffect(() => {
        let jobs = props.jobs.filter(x => x.jobType === DB_JOB_TYPE)
        sortHistories(jobs, props.histories)
    }, [props.histories])

    useEffect(() => {
        if (props.globalFiles.length > 0) {
            setAllGlobalFiles(props.globalFiles)
            let totalPages = Math.ceil(props.globalFiles.length / ENTRIES_PER_PAGE)
            setTotalPagesForGlobalFiles(totalPages)
        }
    }, [props.globalFiles])

    useEffect(() => {
        if (props.selfServeJobs.jobFilesPage !== filesPage) {
            setFilesPage(props.selfServeJobs.jobFilesPage)
        }
    }, [props.selfServeJobs.jobFilesPage])

    useEffect(() => {
        if (props.selfServeJobs.jobsPage !== jobsPage) {
            setJobsPage(props.selfServeJobs.jobsPage)
        }
    }, [props.selfServeJobs.jobsPage])

    useEffect(() => {
        if (props.selfServeJobs.historiesPage !== historiesPage) {
            setHistoriesPage(props.selfServeJobs.historiesPage)
        }
    }, [props.selfServeJobs.historiesPage])

    /**
    * sortHistories
    * * Only displays the histories from jobs that were actually returned from the API endpoint
    * @param {Array} jobsFromProps - Jobs from the API
    * @param {Array} historiesFromProps - Histories from the API
    */
    function sortHistories(jobsFromProps, historiesFromProps) {
        let newHistories = []
        historiesFromProps.forEach(history => {
            jobsFromProps.forEach(job => {
                if (history.dbJobId == job.id) {
                    newHistories.push(history)
                }
            })
        })

        setDbHistoryEntries(newHistories)

        let totalPages = Math.ceil(newHistories.length / ENTRIES_PER_PAGE)
        setTotalPagesForHistories(totalPages)
    }

    function handleNewJobButtonPress(event) {
        event.preventDefault()
        props.showPopup("dataToolsJobTaskList", { jobData: null, databases: sqLDbList, packages: ssisJobs, globalFiles: allGlobalFiles })
    }

    function handleNewFileButtonPress(event) {
        event.preventDefault()
        props.showPopup("databaseJobFileUpload", { jobData: null, existingFiles: props.globalFiles })
    }

    function handleJobSelection(event, jobData) {
        event.preventDefault()

        if (selectedJob && selectedJob.id === jobData.id) {
            setSelectedJob(null)
        } else {
            setSelectedJob(jobData)
        }
        setHistoriesPage(1)
        props.selfServiceChangeFilesPage(1)
        props.selfServiceChangeHistoriesPage(1)
    }

    function renderDatabaseHistoryTableBody() {
        return getAllJobHistoriesOrJustTheSelectedOne(dbHistoryEntries, selectedJob).map((x, i) => {
            return isThisIndexWithinRange(i, historiesPage) ? (
                <TableRow key={x.id}>
                    <TableCell>{x.dbJobId}</TableCell>
                    <TableCell>{x.jobState}</TableCell>
                    <TableCell>{x.userName}</TableCell>
                    <TableCell>{dateParser(x.startDate)}</TableCell>
                    <TableCell>{dateParser(x.stopDate)}</TableCell>
                    <TableCell>
                        <IconButton onClick={() => {
                            props.showPopup("viewDbJobLog", { historyData: x })
                        }}>
                            <VisibilityIcon />
                        </IconButton>
                        {renderProgressBar(x.id)}
                    </TableCell>
                </TableRow>
            ) : null
        })
    }

    function renderProgressBar(id) {
        if (performingJob && parseInt(id) === parseInt(jobProgressId)) {
            return (<div className="progressBar" style={{ width: "100%" }}><div className="filler" style={{ width: `${(currentJobProgress / currentJobTotalParts) * 100}%` }}></div></div>)
        }

        return null
    }

    function renderDatabaseJobs() {
        if (props.role === "IEAdmin" || props.role === "ClientAdmin") {
            return dbJobs.map((x, i) => {
                return isThisIndexWithinRange(i, jobsPage) ? (
                    <TableRow key={x.id} hover={true} selected={selectedJob && x.id === selectedJob.id} onClick={(e) => handleJobSelection(e, x)}>
                        <TableCell>{x.id}</TableCell>
                        <TableCell>{x.jobName}</TableCell>
                        <TableCell>{x.jobDescription}</TableCell>
                        <TableCell>{dateParser(x.createdDate)}</TableCell>
                        <TableCell>{x.createdUserName}</TableCell>
                        <TableCell>{dateParser(x.updateDate)}</TableCell>
                        <TableCell>{x.updateUserName}</TableCell>
                        <TableCell>
                            {renderPlayArrowOrCantPlayButton(x)}
                            <IconButton onClick={() => {
                                props.showPopup("dataToolsJobTaskList", { jobData: x, databases: sqLDbList, packages: ssisJobs, globalFiles: allGlobalFiles })
                            }}>
                                <EditIcon />
                            </IconButton>
                            <IconButton onClick={() => props.showPopup("deleteDbJob", { jobId: x.id })}>
                                <DeleteIcon />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                ) : null
            })
        } else {
            return dbJobs.map((x, i) => {
                return isThisIndexWithinRange(i, jobsPage) ? (
                    <TableRow key={x.id} hover={true} selected={selectedJob && x.id === selectedJob.id} onClick={(e) => handleJobSelection(e, x)}>
                        <TableCell>{x.id}</TableCell>
                        <TableCell>{x.jobName}</TableCell>
                        <TableCell>{x.jobDescription}</TableCell>
                        <TableCell>{dateParser(x.createdDate)}</TableCell>
                        <TableCell>{x.createdUserName}</TableCell>
                        <TableCell>{dateParser(x.updateDate)}</TableCell>
                        <TableCell>{x.updateUserName}</TableCell>
                        <TableCell>
                            {renderPlayArrowOrCantPlayButton(x)}
                            <IconButton onClick={() => {
                                props.showPopup("dataToolsJobTaskList", { jobData: x, databases: sqLDbList, packages: ssisJobs, globalFiles: allGlobalFiles })
                            }}>
                                <EditIcon />
                            </IconButton>
                            <IconButton onClick={() => props.showPopup("deleteDbJob", { jobId: x.id })}>
                                <DeleteIcon />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                ) : null
            })
        }
    }

    function renderDatabaseJobFiles() {
        if (props.role === "IEAdmin" || props.role === "ClientAdmin") {
            return getAllJobFilesOrFilesRelatedToSelectedJob(allGlobalFiles, selectedJob).map((x, i) => {
                return isThisIndexWithinRange(i, filesPage) ? (
                    <TableRow key={x.id}>
                        <TableCell>{x.id}</TableCell>
                        <TableCell>{x.fileName}</TableCell>
                        <TableCell>{dateParser(x.createdDate)}</TableCell>
                        <TableCell>{x.createdUserName}</TableCell>
                        <TableCell>
                            <IconButton onClick={() => {
                                props.showPopup("lookInsideZipFile", { fileData: x.jobFileData })
                            }}>
                                <VisibilityIcon />
                            </IconButton>
                            <IconButton onClick={() => {
                                if (x["fileName"].toLowerCase().endsWith('.json')) {
                                    setWizardFileName(x["fileName"])
                                    setWizardStep('loading-wizard-file')
                                    setWizardFileId(x["id"])
                                    props.openEditNewWizardFile(x["id"]).then((resp) => {
                                        if (resp.status !== 200) {
                                            throw new Error()
                                        } else {
                                            return resp.json()
                                        }
                                    })
                                        .then((json) => {
                                            setTableDefinition(json["tableDefinition"])
                                            setHeaderRow(json["headerRow"])
                                            setFactSourceFirstRow(json["headerRow"])
                                            setFactsColumnRanges(json["factsColumnRanges"])
                                            setDimensions(json["dimensions"])
                                            setAggregationSelections(json["aggregationSelections"])
                                            setSelectedDimension(json["selectedDimension"])
                                            setWizardStep('select-files')
                                        }).catch((ex) => {
                                            console.error(ex)
                                            setWizardStep('')
                                            setWizardFileId(-1)
                                            setWizardFileName('')
                                            setHeaderRow(0)
                                            setFactSourceFirstRow(-1)
                                            setTableDefinition({
                                                "tableHasHeader": false,
                                                "namedColumns": false
                                            })
                                            setFactsColumnRanges([])
                                            setDimensions([])
                                            setAggregationSelections([])
                                        })
                                } else {
                                    props.showPopup("databaseJobFileUpload", { jobData: x, existingFiles: props.globalFiles })
                                }
                            }}>
                                <EditIcon />
                            </IconButton>
                            <IconButton onClick={() => {
                                const VALUE = "Value"
                                let filesBeingUsed = []
                                for (let jobIterator = 0; jobIterator < dbJobs.length; jobIterator++) {
                                    let jobData = JSON.parse(dbJobs[jobIterator]["jobData"])
                                    let jobTasks = jobData["Tasks"]
                                    for (let taskIterator = 0; taskIterator < jobTasks.length; taskIterator++) {
                                        let selectedZipFile = jobTasks[taskIterator][VALUE]["selectedZipFile"]
                                        let selectedFileWithinZip = jobTasks[taskIterator][VALUE]["selectedFileWithinZip"]
                                        let wizardFile = jobTasks[taskIterator][VALUE]["wizardFile"]
                                        let sourceFiles = jobTasks[taskIterator][VALUE]["sourceFiles"]

                                        if (selectedZipFile && selectedZipFile.trim().length > 0) {
                                            filesBeingUsed.push(selectedZipFile)
                                        }

                                        if (selectedFileWithinZip && selectedFileWithinZip.trim().length > 0) {
                                            filesBeingUsed.push(selectedFileWithinZip)
                                        }

                                        if (wizardFile && wizardFile.trim().length > 0) {
                                            filesBeingUsed.push(wizardFile)
                                        }

                                        if (sourceFiles && sourceFiles.length > 0) {
                                            for (let sourceFileItr = 0; sourceFileItr < sourceFiles.length; sourceFileItr++) {
                                                filesBeingUsed.push(sourceFiles[sourceFileItr])
                                            }
                                        }
                                    }
                                }

                                let jobFileData = JSON.parse(x["jobFileData"])
                                props.showPopup("deleteDbJobFile", { fileId: x.id, filesBeingUsed: filesBeingUsed, targetFile: x["fileName"], targetFileId: jobFileData["identifier"] })
                            }}>
                                <DeleteIcon />
                            </IconButton>
                            <IconButton onClick={() => {
                                props.downloadFile(x.id, x.fileName)
                            }}>
                                <DownloadIcon />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                ) : null
            })
        } else {
            return getAllJobFilesOrFilesRelatedToSelectedJob(allGlobalFiles, selectedJob).map((x, i) => {
                return isThisIndexWithinRange(i, filesPage) ? (
                    <TableRow key={x.id}>
                        <TableCell>{x.id}</TableCell>
                        <TableCell>{x.fileName}</TableCell>
                        <TableCell>{dateParser(x.createdDate)}</TableCell>
                        <TableCell>{x.createdUserName}</TableCell>
                        <TableCell>
                            <IconButton onClick={() => {
                                props.showPopup("lookInsideZipFile", { fileData: x.jobFileData })
                            }}>
                                <VisibilityIcon />
                            </IconButton>
                            <IconButton onClick={() => {
                                props.showPopup("databaseJobFileUpload", { jobData: x, existingFiles: props.globalFiles })
                            }}>
                                <EditIcon />
                            </IconButton>
                            <IconButton onClick={() => {
                                const VALUE = "Value"
                                let filesBeingUsed = []

                                for (let jobIterator = 0; jobIterator < dbJobs.length; jobIterator++) {
                                    let jobData = JSON.parse(dbJobs[jobIterator]["jobData"])
                                    let jobTasks = jobData["Tasks"]
                                    for (let taskIterator = 0; taskIterator < jobTasks.length; taskIterator++) {
                                        let selectedZipFile = jobTasks[taskIterator][VALUE]["selectedZipFile"]
                                        let selectedFileWithinZip = jobTasks[taskIterator][VALUE]["selectedFileWithinZip"]
                                        let wizardFile = jobTasks[taskIterator][VALUE]["wizardFile"]
                                        let sourceFiles = jobTasks[taskIterator][VALUE]["sourceFiles"]

                                        if (selectedZipFile && selectedZipFile.trim().length > 0) {
                                            filesBeingUsed.push(selectedZipFile)
                                        }

                                        if (selectedFileWithinZip && selectedFileWithinZip.trim().length > 0) {
                                            filesBeingUsed.push(selectedFileWithinZip)
                                        }

                                        if (wizardFile && wizardFile.trim().length > 0) {
                                            filesBeingUsed.push(wizardFile)
                                        }

                                        if (sourceFiles && sourceFiles.length > 0) {
                                            for (let sourceFileItr = 0; sourceFileItr < sourceFiles.length; sourceFileItr++) {
                                                filesBeingUsed.push(sourceFiles[sourceFileItr])
                                            }
                                        }
                                    }
                                }

                                props.showPopup("deleteDbJobFile", { fileId: x.id, filesBeingUsed: filesBeingUsed, targetFile: x["fileName"] })
                            }}>
                                <DeleteIcon />
                            </IconButton>
                            <IconButton onClick={() => {
                                props.downloadFile(x.id, x.fileName)
                            }}>
                                <DownloadIcon />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                ) : null
            })
        }
    }

    function renderPlayArrowOrCantPlayButton(currentJob) {
        if (jobOnDbIsRunning(currentJob)) {
            return (<IconButton onClick={() => { }}>
                <PlayDisabledIcon />
            </IconButton>)
        }

        return (<IconButton onClick={() => props.showPopup("fireDbJob", { jobData: currentJob })}>
            <PlayArrowIcon />
        </IconButton>)
    }

    function jobOnDbIsRunning(currentJob) {
        let rtnVal = false
        let dbRunningAgainst = ''

        // Go through all jobs, capture the DB we are running a process against
        dbJobs.forEach((current) => {
            dbHistoryEntries.forEach((history) => {
                if (isThisTheCurrentlyRunningJob(current, history)) {
                    dbRunningAgainst = current["database"]
                }
            })
        })

        // Go through all histories, if a job history is running and the currentJob is the same ID, or if the job has a similarly named DB
        if (dbRunningAgainst !== '') {
            dbHistoryEntries.forEach((history) => {
                if (isThisTheCurrentlyRunningJob(currentJob, history) ||
                    (isThisTheCurrentlyRunningDatabase(currentJob, dbRunningAgainst))) {
                    rtnVal = true
                }
            })
        }

        return rtnVal
    }

    function isThisTheCurrentlyRunningJob(currentJob, history) {
        return (history["dbJobId"] == currentJob["id"] && history["jobState"] === "Running")
    }

    function isThisTheCurrentlyRunningDatabase(currentJob, runningDatabase) {
        return (runningDatabase === currentJob["database"])
    }

    function getAllJobFilesOrFilesRelatedToSelectedJob(files, nullableJobData) {
        if (!nullableJobData) {
            return files
        }

        // Just collect all file ids and names first and foremost
        let allCurrentFileNames = []
        const selectedJobInfo = JSON.parse(nullableJobData["jobData"])
        const selectedJobTasks = selectedJobInfo["Tasks"]

        for (let taskItr = 0; taskItr < selectedJobTasks.length; taskItr++) {
            const currentTask = selectedJobTasks[taskItr]
            const currentTaskValue = currentTask["Value"]
            const sourceFiles = currentTaskValue["sourceFiles"]

            if (currentTaskValue["wizardFile"] && currentTaskValue["wizardFile"] !== "") {
                allCurrentFileNames.push(currentTaskValue["wizardFile"])
            }

            if (currentTaskValue["selectedZipFileId"] && currentTaskValue["selectedZipFileId"] !== "") {
                allCurrentFileNames.push(currentTaskValue["selectedZipFileId"])
            }

            for (let sourceItr = 0; sourceItr < sourceFiles.length; sourceItr++) {
                allCurrentFileNames.push(sourceFiles[sourceItr])
            }
        }

        // lets start to use "set" more to stop using so much manual lookups
        const nameSet = new Set(allCurrentFileNames)
        return files.filter(file => {
            const data = JSON.parse(file.jobFileData)
            return nameSet.has(data.identifier)
        })
    }

    function getAllJobHistoriesOrJustTheSelectedOne(histories, nullableJobData) {
        if (!nullableJobData) {
            return histories
        }

        return histories.filter(history => {
            const intId = parseInt(history["dbJobId"])
            return intId === nullableJobData["id"]
        })
    }

    /**
    * isThisIndexWithinRange
    * * Simple and quick method to determine if a certain item is within the asked for page range
    * @param {int} itemIndex - Current index of an item
    * @param {int} pageNumber - Number of the current page
    */
    function isThisIndexWithinRange(itemIndex, pageNumber) {
        let min = (pageNumber - 1) * ENTRIES_PER_PAGE
        let max = (min + ENTRIES_PER_PAGE) - 1
        return itemIndex >= min && itemIndex <= max
    }

    // This is the render logic, no need to declare another method is a functional component
    return (
        <>
            <div className="callsToAction" style={{ margin: "10px 0px", width: "95%", padding: "10px" }}>
                <button type="submit" className="btn" onClick={handleNewJobButtonPress}>Add New Job</button>&nbsp;
                <button type="submit" className="btn" onClick={handleNewFileButtonPress}>Add New Global File</button>&nbsp;
                <button type="submit" className="btn" onClick={(e) => {
                    e.preventDefault()
                    setHeaderRow(0)
                    setFactSourceFirstRow(-1)
                    setTableDefinition({
                        "tableHasHeader": false,
                        "namedColumns": false
                    })
                    setFactsColumnRanges([])
                    setDimensions([])
                    setAggregationSelections([])
                    setWizardFileId(-1)
                    setWizardFileName('')
                    setWizardStep('select-files')
                }}>Add New Wizard File</button>
            </div>
            <Paper elevation={3} className="dbFunctionsPaper">
                <h2>Jobs</h2>
                <Table aria-label="Database Jobs">
                    <TableHead>
                        <TableRow>
                            <TableCell>Job ID</TableCell>
                            <TableCell>Job Name</TableCell>
                            <TableCell>Job Description</TableCell>
                            <TableCell>Created Date</TableCell>
                            <TableCell>Created By</TableCell>
                            <TableCell>Updated Date</TableCell>
                            <TableCell>Updated By</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {renderDatabaseJobs()}
                    </TableBody>
                </Table>
                <Stack spacing={2} alignItems="center" style={{ "margin": "15px auto" }}>
                    <Pagination count={totalPagesForJobs} color="primary" page={jobsPage} onChange={(e, newPage) => {
                        e.preventDefault()
                        setJobsPage(newPage)
                        props.selfServiceChangeJobsPage(newPage)
                    }} />
                </Stack>
            </Paper>
            <Paper elevation={3} className="dbFunctionsPaper">
                <h2>Job Files</h2>
                <Table aria-label="Job Files">
                    <TableHead>
                        <TableRow>
                            <TableCell>Job File ID</TableCell>
                            <TableCell>File Name</TableCell>
                            <TableCell>Created Date</TableCell>
                            <TableCell>Created By</TableCell>
                            <TableCell>View Inside</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {renderDatabaseJobFiles()}
                    </TableBody>
                </Table>
                <Stack spacing={2} alignItems="center" style={{ "margin": "15px auto" }}>
                    <Pagination count={Math.ceil(getAllJobFilesOrFilesRelatedToSelectedJob(allGlobalFiles, selectedJob).length / ENTRIES_PER_PAGE)} color="primary" page={filesPage} onChange={(e, newPage) => {
                        e.preventDefault()
                        setFilesPage(newPage)
                        props.selfServiceChangeFilesPage(newPage)
                    }} />
                </Stack>
            </Paper>
            <Paper elevation={3} className="dbFunctionsPaper">
                <h2>Database Job History</h2>
                <Table aria-label="Database History">
                    <TableHead>
                        <TableRow>
                            <TableCell>Job ID</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>By User</TableCell>
                            <TableCell>Start</TableCell>
                            <TableCell>End</TableCell>
                            <TableCell>View Log</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {renderDatabaseHistoryTableBody()}
                    </TableBody>
                </Table>
                <Stack spacing={2} alignItems="center" style={{ "margin": "15px auto" }}>
                    <Pagination count={Math.ceil(getAllJobHistoriesOrJustTheSelectedOne(dbHistoryEntries, selectedJob).length / ENTRIES_PER_PAGE)} color="primary" page={historiesPage} onChange={(e, newPage) => {
                        e.preventDefault()
                        setHistoriesPage(newPage)
                        props.selfServiceChangeHistoriesPage(newPage)
                    }} />
                </Stack>
            </Paper>
            <NewWizardDialog
                wizardStep={wizardStep}
                globalFiles={allGlobalFiles}
                tableDefinition={tableDefinition}
                headerRow={headerRow}
                factSourceFirstRow={factSourceFirstRow}
                factsColumnRanges={factsColumnRanges}
                dimensions={dimensions}
                aggregationSelections={aggregationSelections}
                selectedDimension={selectedDimension}
                wizardFileName={wizardFileName}
                wizardFileId={wizardFileId}
                onClose={() => {
                    setHeaderRow(0)
                    setFactSourceFirstRow(-1)
                    setTableDefinition({
                        "tableHasHeader": false,
                        "namedColumns": false
                    })
                    setFactsColumnRanges([])
                    setDimensions([])
                    setAggregationSelections([])
                    setWizardFileId(-1)
                    setWizardFileName('')
                    setWizardStep('')
                }}>
            </NewWizardDialog>
        </>
    )
}

export default TabDataTools